const countries = {
    'en': {
        'af': 'Afghanistan',
        'al': 'Albania',
        'dz': 'Algeria',
        'as': 'American Samoa',
        'ad': 'Andorra',
        'ao': 'Angola',
        'ai': 'Anguilla',
        'aq': 'Antarctica',
        'ag': 'Antigua and Barbuda',
        'ar': 'Argentina',
        'am': 'Armenia',
        'aw': 'Aruba',
        'au': 'Australia',
        'at': 'Austria',
        'az': 'Azerbaijan',
        'bs': 'Bahamas (the)',
        'bh': 'Bahrain',
        'bd': 'Bangladesh',
        'bb': 'Barbados',
        'by': 'Belarus',
        'be': 'Belgium',
        'bz': 'Belize',
        'bj': 'Benin',
        'bm': 'Bermuda',
        'bt': 'Bhutan',
        'bo': 'Bolivia (Plurinational State of)',
        'bq': 'Bonaire, Sint Eustatius and Saba',
        'ba': 'Bosnia and Herzegovina',
        'bw': 'Botswana',
        'bv': 'Bouvet Island',
        'br': 'Brazil',
        'io': 'British Indian Ocean Territory (the)',
        'bn': 'Brunei Darussalam',
        'bg': 'Bulgaria',
        'bf': 'Burkina Faso',
        'bi': 'Burundi',
        'cv': 'Cabo Verde',
        'kh': 'Cambodia',
        'cm': 'Cameroon',
        'ca': 'Canada',
        'ky': 'Cayman Islands (the)',
        'cf': 'Central African Republic (the)',
        'td': 'Chad',
        'cl': 'Chile',
        'cn': 'China',
        'cx': 'Christmas Island',
        'cc': 'Cocos (Keeling) Islands (the)',
        'co': 'Colombia',
        'km': 'Comoros (the)',
        'cd': 'Congo (the Democratic Republic of the)',
        'cg': 'Congo (the)',
        'ck': 'Cook Islands (the)',
        'cr': 'Costa Rica',
        'hr': 'Croatia',
        'cu': 'Cuba',
        'cw': 'Curaçao',
        'cy': 'Cyprus',
        'cz': 'Czech Republic',
        'ci': 'Côte d\'Ivoire',
        'dk': 'Denmark',
        'dj': 'Djibouti',
        'dm': 'Dominica',
        'do': 'Dominican Republic (the)',
        'ec': 'Ecuador',
        'eg': 'Egypt',
        'sv': 'El Salvador',
        'gq': 'Equatorial Guinea',
        'er': 'Eritrea',
        'ee': 'Estonia',
        'sz': 'Eswatini',
        'et': 'Ethiopia',
        'fk': 'Falkland Islands (the) [Malvinas]',
        'fo': 'Faroe Islands (the)',
        'fj': 'Fiji',
        'fi': 'Finland',
        'fr': 'France',
        'gf': 'French Guiana',
        'pf': 'French Polynesia',
        'tf': 'French Southern Territories (the)',
        'ga': 'Gabon',
        'gm': 'Gambia (the)',
        'ge': 'Georgia',
        'de': 'Germany',
        'gh': 'Ghana',
        'gi': 'Gibraltar',
        'gr': 'Greece',
        'gl': 'Greenland',
        'gd': 'Grenada',
        'gp': 'Guadeloupe',
        'gu': 'Guam',
        'gt': 'Guatemala',
        'gg': 'Guernsey',
        'gn': 'Guinea',
        'gw': 'Guinea-Bissau',
        'gy': 'Guyana',
        'ht': 'Haiti',
        'hm': 'Heard Island and McDonald Islands',
        'va': 'Holy See (the)',
        'hn': 'Honduras',
        'hk': 'Hong Kong',
        'hu': 'Hungary',
        'is': 'Iceland',
        'in': 'India',
        'id': 'Indonesia',
        'ir': 'Iran (Islamic Republic of)',
        'iq': 'Iraq',
        'ie': 'Ireland',
        'im': 'Isle of Man',
        'il': 'Israel',
        'it': 'Italy',
        'jm': 'Jamaica',
        'jp': 'Japan',
        'je': 'Jersey',
        'jo': 'Jordan',
        'kz': 'Kazakhstan',
        'ke': 'Kenya',
        'ki': 'Kiribati',
        'kp': 'Korea (the Democratic People\'s Republic of)',
        'kr': 'Korea (the Republic of)',
        'kw': 'Kuwait',
        'kg': 'Kyrgyzstan',
        'la': 'Lao People\'s Democratic Republic (the)',
        'lv': 'Latvia',
        'lb': 'Lebanon',
        'ls': 'Lesotho',
        'lr': 'Liberia',
        'ly': 'Libya',
        'li': 'Liechtenstein',
        'lt': 'Lithuania',
        'lu': 'Luxembourg',
        'mo': 'Macao',
        'mg': 'Madagascar',
        'mw': 'Malawi',
        'my': 'Malaysia',
        'mv': 'Maldives',
        'ml': 'Mali',
        'mt': 'Malta',
        'mh': 'Marshall Islands (the)',
        'mq': 'Martinique',
        'mr': 'Mauritania',
        'mu': 'Mauritius',
        'yt': 'Mayotte',
        'mx': 'Mexico',
        'fm': 'Micronesia (Federated States of)',
        'md': 'Moldova',
        'mc': 'Monaco',
        'mn': 'Mongolia',
        'me': 'Montenegro',
        'ms': 'Montserrat',
        'ma': 'Morocco',
        'mz': 'Mozambique',
        'mm': 'Myanmar',
        'na': 'Namibia',
        'nr': 'Nauru',
        'np': 'Nepal',
        'nl': 'Netherlands (the)',
        'nc': 'New Caledonia',
        'nz': 'New Zealand',
        'ni': 'Nicaragua',
        'ne': 'Niger (the)',
        'ng': 'Nigeria',
        'nu': 'Niue',
        'nf': 'Norfolk Island',
        'mp': 'Northern Mariana Islands (the)',
        'no': 'Norway',
        'om': 'Oman',
        'pk': 'Pakistan',
        'pw': 'Palau',
        'ps': 'Palestine, State of',
        'pa': 'Panama',
        'pg': 'Papua New Guinea',
        'py': 'Paraguay',
        'pe': 'Peru',
        'ph': 'Philippines (the)',
        'pn': 'Pitcairn',
        'pl': 'Poland',
        'pt': 'Portugal',
        'pr': 'Puerto Rico',
        'qa': 'Qatar',
        'mk': 'Republic of North Macedonia',
        'ro': 'Romania',
        'ru': 'Russia',
        'rw': 'Rwanda',
        're': 'Réunion',
        'bl': 'Saint Barthélemy',
        'sh': 'Saint Helena, Ascension and Tristan da Cunha',
        'kn': 'Saint Kitts and Nevis',
        'lc': 'Saint Lucia',
        'mf': 'Saint Martin (French part)',
        'pm': 'Saint Pierre and Miquelon',
        'vc': 'Saint Vincent and the Grenadines',
        'ws': 'Samoa',
        'sm': 'San Marino',
        'st': 'Sao Tome and Principe',
        'sa': 'Saudi Arabia',
        'sn': 'Senegal',
        'rs': 'Serbia',
        'sc': 'Seychelles',
        'sl': 'Sierra Leone',
        'sg': 'Singapore',
        'sx': 'Sint Maarten (Dutch part)',
        'sk': 'Slovakia',
        'si': 'Slovenia',
        'sb': 'Solomon Islands',
        'so': 'Somalia',
        'za': 'South Africa',
        'gs': 'South Georgia and the South Sandwich Islands',
        'ss': 'South Sudan',
        'es': 'Spain',
        'lk': 'Sri Lanka',
        'sd': 'Sudan (the)',
        'sr': 'Suriname',
        'sj': 'Svalbard and Jan Mayen',
        'se': 'Sweden',
        'ch': 'Switzerland',
        'sy': 'Syrian Arab Republic',
        'tw': 'Taiwan (Province of China)',
        'tj': 'Tajikistan',
        'tz': 'Tanzania, United Republic of',
        'th': 'Thailand',
        'tl': 'Timor-Leste',
        'tg': 'Togo',
        'tk': 'Tokelau',
        'to': 'Tonga',
        'tt': 'Trinidad and Tobago',
        'tn': 'Tunisia',
        'tr': 'Turkey',
        'tm': 'Turkmenistan',
        'tc': 'Turks and Caicos Islands (the)',
        'tv': 'Tuvalu',
        'ug': 'Uganda',
        'ua': 'Ukraine',
        'ae': 'United Arab Emirates (the)',
        'gb': 'United Kingdom',
        'um': 'United States Minor Outlying Islands (the)',
        'us': 'United States of America',
        'uy': 'Uruguay',
        'uz': 'Uzbekistan',
        'vu': 'Vanuatu',
        've': 'Venezuela (Bolivarian Republic of)',
        'vn': 'Viet Nam',
        'vg': 'Virgin Islands (British)',
        'vi': 'Virgin Islands (U.S.)',
        'wf': 'Wallis and Futuna',
        'eh': 'Western Sahara',
        'ye': 'Yemen',
        'zm': 'Zambia',
        'zw': 'Zimbabwe',
        'ax': 'Åland Islands',
    },
    'ru': {
        'au': 'Австралия',
        'at': 'Австрия',
        'az': 'Азербайджан',
        'ax': 'Аландские острова',
        'al': 'Албания',
        'dz': 'Алжир',
        'vi': 'Виргинские Острова (США)',
        'as': 'Американское Самоа',
        'ai': 'Ангилья',
        'ao': 'Ангола',
        'ad': 'Андорра',
        'aq': 'Антарктика',
        'ag': 'Антигуа и Барбуда',
        'ar': 'Аргентина',
        'am': 'Армения',
        'aw': 'Аруба',
        'af': 'Афганистан',
        'bs': 'Багамские Острова',
        'bd': 'Бангладеш',
        'bb': 'Барбадос',
        'bh': 'Бахрейн',
        'bz': 'Белиз',
        'by': 'Беларусь',
        'be': 'Бельгия',
        'bj': 'Бенин',
        'bm': 'Бермуды',
        'bg': 'Болгария',
        'bo': 'Боливия',
        'bq': 'Бонэйр, Синт-Эстатиус и Саба',
        'ba': 'Босния и Герцеговина',
        'bw': 'Ботсвана',
        'br': 'Бразилия',
        'io': 'Британская территория в Индийском океане',
        'vg': 'Виргинские Острова (Великобритания)',
        'bn': 'Бруней',
        'bf': 'Буркина-Фасо',
        'bi': 'Бурунди',
        'bt': 'Бутан',
        'vu': 'Вануату',
        'va': 'Ватикан',
        'gb': 'Великобритания',
        'hu': 'Венгрия',
        've': 'Венесуэла',
        'um': 'Внешние малые острова США',
        'tl': 'Восточный Тимор',
        'vn': 'Вьетнам',
        'ga': 'Габон',
        'ht': 'Гаити',
        'gy': 'Гайана',
        'gm': 'Гамбия',
        'gh': 'Гана',
        'gp': 'Гваделупа',
        'gt': 'Гватемала',
        'gf': 'Гвиана',
        'gn': 'Гвинея',
        'gw': 'Гвинея-Бисау',
        'de': 'Германия',
        'gg': 'Гернси',
        'gi': 'Гибралтар',
        'hn': 'Гондурас',
        'hk': 'Гонконг',
        'gd': 'Гренада',
        'gl': 'Гренландия',
        'gr': 'Греция',
        'ge': 'Грузия',
        'gu': 'Гуам',
        'dk': 'Дания',
        'je': 'Джерси',
        'dj': 'Джибути',
        'dm': 'Доминика',
        'do': 'Доминиканская Республика',
        'cd': 'ДР Конго',
        'eu': 'Флаг ЕС Европейский союз',
        'eg': 'Египет',
        'zm': 'Замбия',
        'eh': 'САДР',
        'zw': 'Зимбабве',
        'il': 'Израиль',
        'in': 'Индия Индия',
        'id': 'Индонезия',
        'jo': 'Иордания',
        'iq': 'Ирак',
        'ir': 'Иран',
        'ie': 'Ирландия',
        'is': 'Исландия',
        'es': 'Испания',
        'it': 'Италия',
        'ye': 'Йемен',
        'cv': 'Кабо-Верде',
        'kz': 'Казахстан',
        'ky': 'Острова Кайман',
        'kh': 'Камбоджа',
        'cm': 'Камерун',
        'ca': 'Канада',
        'qa': 'Катар',
        'ke': 'Кения',
        'cy': 'Кипр',
        'kg': 'Киргизия',
        'ki': 'Кирибати',
        'tw': 'Китайская Республика',
        'kp': 'КНДР (Корейская Народно-Демократическая Республика)',
        'cn': 'Китай (Китайская Народная Республика)',
        'cc': 'Кокосовые острова',
        'co': 'Колумбия',
        'km': 'Коморы',
        'cr': 'Коста-Рика',
        'ci': 'Кот-д’Ивуар',
        'cu': 'Куба',
        'kw': 'Кувейт',
        'cw': 'Кюрасао',
        'la': 'Лаос',
        'lv': 'Латвия',
        'ls': 'Лесото',
        'lr': 'Либерия',
        'lb': 'Ливан',
        'ly': 'Ливия',
        'lt': 'Литва',
        'li': 'Лихтенштейн',
        'lu': 'Люксембург',
        'mu': 'Маврикий',
        'mr': 'Мавритания',
        'mg': 'Мадагаскар',
        'yt': 'Майотта',
        'mo': 'Макао',
        'mk': 'Северная Македония',
        'mw': 'Малави',
        'my': 'Малайзия',
        'ml': 'Мали',
        'mv': 'Мальдивы',
        'mt': 'Мальта',
        'ma': 'Марокко',
        'mq': 'Мартиника',
        'mh': 'Маршалловы Острова',
        'mx': 'Мексика',
        'fm': 'Микронезия',
        'mz': 'Мозамбик',
        'md': 'Молдавия',
        'mc': 'Монако',
        'mn': 'Монголия',
        'ms': 'Монтсеррат',
        'mm': 'Мьянма',
        'na': 'Намибия',
        'nr': 'Науру',
        'np': 'Непал',
        'ne': 'Нигер',
        'ng': 'Нигерия',
        'nl': 'Нидерланды',
        'ni': 'Никарагуа',
        'nu': 'Ниуэ',
        'nz': 'Новая Зеландия',
        'nc': 'Новая Каледония',
        'no': 'Норвегия',
        'ae': 'ОАЭ',
        'om': 'Оман',
        'bv': 'Остров Буве',
        'im': 'Остров Мэн',
        'ck': 'Острова Кука',
        'nf': 'Остров Норфолк',
        'cx': 'Остров Рождества',
        'pn': 'Острова Питкэрн',
        'sh': 'Острова Святой Елены, Вознесения и Тристан-да-Кунья',
        'pk': 'Пакистан',
        'pw': 'Палау',
        'ps': 'Государство Палестина',
        'pa': 'Панама',
        'pg': 'Папуа — Новая Гвинея',
        'py': 'Парагвай',
        'pe': 'Перу',
        'pl': 'Польша',
        'pt': 'Португалия',
        'pr': 'Пуэрто-Рико',
        'cg': 'Республика Конго',
        'kr': 'Республика Корея',
        're': 'Реюньон',
        'ru': 'Россия',
        'rw': 'Руанда',
        'ro': 'Румыния',
        'sv': 'Сальвадор',
        'ws': 'Самоа',
        'sm': 'Сан-Марино',
        'st': 'Сан-Томе и Принсипи',
        'sa': 'Саудовская Аравия',
        'sz': 'Эсватини',
        'mp': 'Северные Марианские Острова',
        'sc': 'Сейшельские Острова',
        'bl': 'Сен-Бартелеми (Карибы)',
        'mf': 'Сен-Мартен',
        'pm': 'Сен-Пьер и Микелон',
        'sn': 'Сенегал',
        'vc': 'Сент-Винсент и Гренадины',
        'kn': 'Сент-Китс и Невис',
        'lc': 'Сент-Люсия',
        'rs': 'Сербия',
        'sg': 'Сингапур',
        'sx': 'Синт-Мартен',
        'sy': 'Сирия',
        'sk': 'Словакия',
        'si': 'Словения',
        'sb': 'Соломоновы Острова',
        'so': 'Сомали',
        'sd': 'Судан',
        'sr': 'Суринам',
        'us': 'США',
        'sl': 'Сьерра-Леоне',
        'tj': 'Таджикистан',
        'th': 'Таиланд',
        'tz': 'Танзания',
        'tc': 'Теркс и Кайкос',
        'tg': 'Того',
        'tk': 'Токелау',
        'to': 'Тонга',
        'tt': 'Тринидад и Тобаго',
        'tv': 'Тувалу',
        'tn': 'Тунис',
        'tm': 'Туркмения',
        'tr': 'Турция',
        'ug': 'Уганда',
        'uz': 'Узбекистан',
        'ua': 'Украина',
        'wf': 'Уоллис и Футуна',
        'uy': 'Уругвай',
        'fo': 'Фарерские острова',
        'fj': 'Фиджи',
        'ph': 'Филиппины',
        'fi': 'Финляндия',
        'fk': 'Фолклендские острова',
        'fr': 'Франция',
        'pf': 'Французская Полинезия',
        'tf': 'Французские Южные и Антарктические территории',
        'hm': 'Херд и Макдональд',
        'hr': 'Хорватия',
        'cf': 'ЦАР',
        'td': 'Чад',
        'me': 'Черногория',
        'cz': 'Чешская Республика',
        'cl': 'Чили',
        'ch': 'Швейцария',
        'se': 'Швеция',
        'sj': 'Флаг Шпицбергена и Ян-Майена Шпицберген и Ян-Майен',
        'lk': 'Шри-Ланка',
        'ec': 'Эквадор',
        'gq': 'Экваториальная Гвинея',
        'er': 'Эритрея',
        'ee': 'Эстония',
        'et': 'Эфиопия',
        'za': 'ЮАР',
        'gs': 'Южная Георгия и Южные Сандвичевы Острова',
        'ss': 'Южный Судан',
        'jm': 'Ямайка',
        'jp': 'Япония'
    }
}


export default countries



// WEBPACK FOOTER //
// ./utils/countries.js